// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZYlvE","delete":"styles_delete__1FP1g","update":"styles_update__1z-G4","add":"styles_add__2bgai"};